import React, { useLayoutEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import HeaderButton from '../../../components/Buttons/HeaderButton';
import OrganizationsList from './components/OrganizationsList';
import MainButton from '../../../components/Buttons/MainButton';

const OrganizationsScreen = ({ navigation }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: 'Organizations',
            headerRight: () => (
                <HeaderButton
                    onPress={() => { navigation.navigate('SuperDuperAdminCreateOrganization') }}
                    accessibilityLabel="Create new organization"
                    accessibilityHint="Press this button to create a new organization"
                    buttonText="Create"
                />
            ),
            headerLeft: null
        });
    }, [navigation]);

    const CreateButtonComponent = (
        <MainButton
            onPress={() => { navigation.navigate('SuperDuperAdminCreateOrganization') }}
            text={'Create Organization'}
            accessibilityLabel="Create new organization"
            accessibilityHint="Press this button to create a new organization"
        />
    )

    return (
        <View style={styles.screen}>
            <OrganizationsList
                noOrgsMessageLineOne={"Is that crickets I hear?  👀"}
                noOrgsMessageLineTwo={'Maybe if we create some organizations they will go away.'}
                onEmptyOrgsListCreateBtnPress={() => {
                    navigation.navigate('SuperDuperAdminCreateOrganization')
                }}
                ListFooterComponent={CreateButtonComponent}
                onEditButtonPress={(organizationId) => navigation.navigate('SuperDuperAdminEditOrganization', {
                    organizationId: organizationId
                })}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    screen: {
        flex: 1,
    }
});

export default OrganizationsScreen;